import React, { Component, Fragment } from 'react';
import './AddItemSolicitud.css';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import TextField from '@mui/material/TextField';
import MyButton from '../../../utils/MyButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

import CircularProgress from '@mui/material/CircularProgress';

import { FaArrowLeft, FaPlus } from "react-icons/fa";

import { postItemSolicitud, clearErrors } from '../../../redux/actions/dataasistencialactions';

export class AddItemSolicitud extends Component {
  constructor() {
    super();
    this.state = {
      nombre: '',
      marca: '',
      cantidad: '',
      descripcion: '',
      estado: '',
      precio: '',
      open: false,
      errors: {}
    };

  };
  static getDerivedStateFromProps(props, state) {
    return props.UI.errors ? { errors: props.UI.errors } : null;

  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.clearErrors();
    this.setState({
      nombre: '',
      marca: '',
      cantidad: '',
      descripcion: '',
      estado: '',
      precio: '',
      open: false,
      errors: {}
    });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });

  };


  handleSubmit = (event) => {
    event.preventDefault();
    const newItem = {
      nombre: this.state.nombre,
      marca: this.state.marca,
      descripcion: this.state.descripcion,
      cantidad: this.state.cantidad
    };

    console.log(newItem);
    console.log(this.props.solicitudId);
    this.props.postItemSolicitud(newItem, this.props.solicitudId);


    // this.props.progMto(newProgramacion,this.props.clienteId,this.props.equipoId); 
    //Aqui se postea al cliente


  }
  render() {

    const { UI: { loading } } = this.props;
    const { errors } = this.state;


    return (
      <Fragment>
        <MyButton tip="Añadir un Item" onClick={this.handleOpen}>
          <FaPlus color="#03178C" className="icon-crearcliente" />
        </MyButton>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle sx={{ color: "#03178C" }}>Añadir Item</DialogTitle>

          <DialogContent>
            <form>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    type="text"
                    name="nombre"
                    id="nombre"
                    label="Nombre del Item"
                    value={this.state.nombre}
                    onChange={this.handleChange}
                    fullWidth
                    variant="outlined"
                    helperText={errors.nombre}
                    error={errors.nombre ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    type="text"
                    name="marca"
                    id="marca"
                    label="Marca"
                    value={this.state.marca}
                    onChange={this.handleChange}
                    fullWidth
                    variant="outlined"
                    helperText={errors.marca}
                    error={errors.marca ? true : false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    type="number"
                    name="cantidad"
                    id="cantidad"
                    label="Cantidad"
                    value={this.state.cantidad}
                    onChange={this.handleChange}
                    fullWidth
                    variant="outlined"
                    helperText={errors.cantidad}
                    error={errors.cantidad ? true : false}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    type="text"
                    name="descripcion"
                    id="descripcion"
                    label="Descripcion/Observaciones"
                    value={this.state.descripcion}
                    onChange={this.handleChange}
                    fullWidth
                    variant="outlined"
                    helperText={errors.descripcion}
                    error={errors.descripcion ? true : false}
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
            </form>
          </DialogContent>


          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>

            {loading ? <CircularProgress size={30} color="primary" className="login-progress" /> :
              <MyButton tip="Añadir Item" onClick={this.handleSubmit}>
                <FaPlus color="#03178C" className="icon-formulario" />
              </MyButton>}




          </DialogActions>

        </Dialog>

      </Fragment>
    )
  }
}

AddItemSolicitud.propTypes = {
  postItemSolicitud: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired
};
const mapStateToProps = (state) => ({
  UI: state.UI,
  cotizacion: state.dataSales.cotizacion.credentials
});

export default connect(mapStateToProps, { postItemSolicitud, clearErrors })(AddItemSolicitud)
